module.exports = __webpack_public_path__ + "img/jygl.00277220.png";